import useRequest from "./Request";
const useApi = () => {
  const Request = useRequest();
  const Api = {
    get: (url) => Request(url),
    post: (url, body, headers, isFormData = false) =>
      Request(
        url,
        {
          method: "POST",
          body: body === null ? null : isFormData ? body : JSON.stringify(body),
        },
        headers,
        isFormData
      ),
    put: (url, body, headers, isFormData = false) =>
      Request(
        url,
        { method: "PUT", body: isFormData ? body : JSON.stringify(body) },
        headers,
        isFormData
      ),
    delete: (url, body, headers) =>
      Request(url, { method: "DELETE", body: body }, headers),
  };
  return Api;
};

export default useApi;
